import { Typography } from '@mui/material';
import React from 'react';
import { bajajPrimaryBlue } from '../../theme/palette';
import { MuiStack } from '../atoms/stackComponent';
import { MuiButton } from '../atoms/buttonComponent';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
var PageNotFoundComponent = function (props) {
    var navigate = useNavigate();
    return /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        direction: 'column',
        height: 'calc(100vh)',
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            textAlign: 'center',
            fontSize: '70px',
            color: bajajPrimaryBlue
        }
    }, "404"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        sx: {
            color: '#8593A3',
            textAlign: 'center'
        }
    }, "Page not found"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        name: t('Go to home'),
        onClick: function () {
            navigate('/dashboard');
        }
    })));
};
export default PageNotFoundComponent;
